import React, { useState } from "react";
import { Container } from "reactstrap";
import { useApi } from "../../hooks/useApi";
import api from "../../utils/api";

import FormModal from "../../components/FormModal/FormModal";

import favoriteFull from "../../assets/images/favorite-full.svg";
import { loadMoreTexts, getLocalItems } from "../../assets/Helpers";
import ThemeSection from "../../components/ThemeSection/ThemeSection";
import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";

import NavigationButton from "../../components/Buttons/NavigationButton/NavigationButton";

import ProductItem from "../../components/ProductSection/ProductItem/ProductItem";
import ProductsLoader from "../../components/ProductSection/ProductsContainer/ProductsLoader";
import ProductsContainer from "../../components/ProductSection/ProductsContainer/ProductsContainer";
import ProductTitleLoader from "../../components/ProductSection/ProductSectionTitle/ProductTitleLoader";
import ProductSectionTitle from "../../components/ProductSection/ProductSectionTitle/ProductSectionTitle";

import "./Favorites.scss";

const Favorites = () => {
  const localItems = getLocalItems();
  const localFavorites = localItems ? JSON.parse(localItems).favorites : [];

  const [favorites, setFavorites] = useState(localFavorites || []);
  const [hasNoItems, setNoItems] = useState(favorites.length === 0);

  const [buttonText, setButtonText] = useState(loadMoreTexts.default);

  const [currentPage, setCurrentPage] = useState(1);
  // Get products by IDs from favorites
  const { data: productsData, loading, error, refetch } = useApi(
    () => {
      if (!favorites || favorites.length === 0) {
        return Promise.resolve({ products: [] });
      }
      // Fetch all products and filter client-side (or add endpoint to filter by IDs)
      return api.getProducts({ limit: 90, page: currentPage });
    },
    [favorites, currentPage]
  );

  // Filter products to only show favorites
  const favoriteProducts = (productsData?.products || []).filter(p => 
    favorites.includes(p.productId)
  );

  const data = {
    products: {
      nodes: favoriteProducts,
      pageInfo: {
        hasNextPage: productsData?.pagination ? productsData.pagination.page < productsData.pagination.totalPages : false,
        endCursor: productsData?.pagination?.page?.toString() || "1",
      },
    },
  };

  if (hasNoItems) {
    return (
      <div className="Favorites">
        <FormModal centered>
          <div className="Favorites__icon">
            <img src={favoriteFull} alt="Empty Favorites" />
          </div>
          <p className="Favorites__desc">
            Ju momentalisht nuk keni ndonje produkt ne listë!
          </p>
          <NavigationButton to="/" title="Shto produkte" />
        </FormModal>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="Favorites">
        <Container>
          <ThemeSection>
            <ProductTitleLoader />
            <ProductsLoader total="12" />
          </ThemeSection>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="Favorites">
        <Container>
          <ThemeSection>
            <p>Ju lutemi provoni përseri.</p>
          </ThemeSection>
        </Container>
      </div>
    );
  }

  const isArchive = true;
  const products = data.products.nodes;

  const handleClick = async () => {
    setButtonText(loadMoreTexts.loading);
    const nextPage = currentPage + 1;
    
    try {
      setCurrentPage(nextPage);
      setButtonText(loadMoreTexts.default);
    } catch (error) {
      console.error("Error loading more:", error);
      setButtonText(loadMoreTexts.default);
    }
  };

  const handleRemove = (id) => {
    // Remove from favorites in localStorage
    const updatedFavorites = favorites.filter(favId => favId !== id);
    setFavorites(updatedFavorites);
    
    // Update localStorage
    const localItems = getLocalItems();
    if (localItems) {
      const items = JSON.parse(localItems);
      items.favorites = updatedFavorites;
      localStorage.setItem('localItems', JSON.stringify(items));
    }
    
    // Update hasNoItems state
    setNoItems(updatedFavorites.length === 0);
    
    // Refetch products to update the list
    refetch();
  };

  return (
    <div className="Favorites">
      <Container>
        <ThemeSection>
          <ProductSectionTitle isArchive={isArchive} title="Lista ime" />
          <ProductsContainer>
            {products.map((product, index) => {
              return (
                <ProductItem
                  key={product.id}
                  isFavorite={true}
                  isFavorites={true}
                  onRemove={handleRemove}
                  {...product}
                />
              );
            })}
          </ProductsContainer>
        </ThemeSection>
        {isArchive && data.products.pageInfo.hasNextPage && (
          <LoadMoreButton title={buttonText} onClick={() => handleClick()} />
        )}
      </Container>
    </div>
  );
};

export default Favorites;
